import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'reactstrap'

import { DiningMethodButtonGroup, Loader, PickupDateTimePicker } from '@components'
import { DINING_METHOD, DINING_METHOD_OPTIONS, ROUTES, COLORS, customToast } from '@common'
import { useAuth, useCartRedux, useDashboardRedux, useUserRedux } from '@hooks'

export default function HomePage() {
    const navigate = useNavigate()
    const { diningMethod, tableId, setDiningMethod, setTableId, setPickupDate, setPickupTime, setTargetStallId } = useUserRedux()
    const { isLoading: isDashboardLoading, tables, fetchCafeConfig } = useDashboardRedux()
    const { clearCart } = useCartRedux()
    const { isAuthenticated } = useAuth()

    const [pickupDateTime, setPickupDateTime] = useState(null)

    useEffect(() => {
        clearCart()
        fetchCafeConfig()

        // Read stall ID from URL parameter
        const queryParams = new URLSearchParams(window.location.search)
        const stallId = queryParams.get('stall')

        if (stallId) {
            const parsedStallId = parseInt(stallId)
            if (!isNaN(parsedStallId)) {
                setTargetStallId(parsedStallId)
            }
        }
        // eslint-disable-next-line
    }, [])

    const onCheckOrderStatus = () => {
        navigate(ROUTES.Order.search)
    }

    const onViewMenu = () => {
        // Check if user selected Advance Takeaway but not logged in
        if (diningMethod.value === DINING_METHOD.AdvanceTakeaway && !isAuthenticated) {
            customToast.error('You must be logged in to select Advance Takeaway')
            return
        }

        if (diningMethod.value === DINING_METHOD.AdvanceTakeaway && !pickupDateTime) {
            customToast.error('Please provide pickup date and time')
            return
        }

        if (diningMethod.value === DINING_METHOD.DineIn && !tableId) {
            const unknownTable = tables.find(table => table.name === 'Unknown')
            if (unknownTable) {
                setTableId({ value: unknownTable.id, label: 'Unknown' })
            }
        }

        navigate(ROUTES.Table.root)
    }

    const onDiningMethodChange = value => {
        setDiningMethod(value)

        // Auto set Unknown table when DineIn is selected
        if (value.value === DINING_METHOD.DineIn) {
            const unknownTable = tables.find(table => table.name === 'Unknown')
            if (unknownTable) {
                setTableId({ value: unknownTable.id, label: 'Unknown' })
            } else {
                setTableId(null)
            }
        } else {
            setTableId(null)
        }

        setPickupDate(null)
        setPickupTime(null)
        setPickupDateTime(null)
    }

    const handleDateTimeChange = ({ date, time, dateTime }) => {
        setPickupDateTime({ date, time, dateTime })
        setPickupDate(date)
        setPickupTime(time)
    }

    return (
        <div className="home-page">
            {isDashboardLoading && <Loader />}

            <div
                className="note-container mt-4"
                style={{
                    backgroundColor: COLORS.WARNING.background,
                    padding: '16px',
                    borderRadius: '8px',
                    border: `1px solid ${COLORS.WARNING.border}`,
                }}
            >
                <p style={{ margin: 0, color: COLORS.WARNING.text, fontSize: '14px' }}>
                    Note: You can order from multiple stalls in a single checkout and make a single payment via Paynow on your
                    mobile or by cash at the drink stall cashier.
                </p>
            </div>
            <DiningMethodButtonGroup
                value={diningMethod.value}
                options={DINING_METHOD_OPTIONS}
                onChange={onDiningMethodChange}
                containerClassName="mt-4"
            />
            {diningMethod.value === DINING_METHOD.AdvanceTakeaway && (
                <PickupDateTimePicker value={pickupDateTime} onChange={handleDateTimeChange} containerClassName="mt-4" />
            )}
            <div className="button-container mt-4">
                <Button
                    color="primary"
                    className="w-100"
                    onClick={onViewMenu}
                    style={{
                        padding: '14px',
                        fontSize: '16px',
                        fontWeight: '500',
                        borderRadius: '8px',
                    }}
                >
                    View Menu
                </Button>
                <Button
                    outline
                    color="primary"
                    className="w-100"
                    onClick={onCheckOrderStatus}
                    style={{
                        marginTop: '12px',
                        padding: '14px',
                        fontSize: '16px',
                        fontWeight: '500',
                        borderRadius: '8px',
                    }}
                >
                    Check Order Status
                </Button>
            </div>
        </div>
    )
}
